import "./Loader.css"; 

const Loader = () => {
  return (
    <div className="loading">
      <div className="loader"></div> // Render a loader div inside a loading container
    </div>
  );
};

export default Loader; 